import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

// Components
import { Container, Navbar, Nav } from "react-bootstrap";

// Actions
import { IMAGES } from "../constants";

export const BusinessBar = ({ auth: { user, groups, userGroup } }) => {
  return (
    <>
      {user && userGroup ? (
        <Navbar expand="lg" variant="light" bg="light">
          <Container fluid className="settings-container">
            <Navbar.Brand
              href="https://www.sproutqr.com/"
              className={groups.length > 1 ? "d-none d-lg-block" : ""}
            >
              <img
                src={IMAGES.ONBOARDING_LOGO}
                alt="logo"
                width="346"
                height="85"
              />
            </Navbar.Brand>
            {/**
             * Only display if there is more than one business
             * then display list group to change business
             */}
            {groups.length > 1 && (
              <>
                <Navbar.Brand
                  href="https://www.sproutqr.com/"
                  className="p-0 d-block d-lg-none"
                >
                  <img
                    src={IMAGES.ONBOARDING_LOGO_MOBILE}
                    alt="logo"
                    width="45"
                    height="45"
                  />
                </Navbar.Brand>
                <Nav className="justify-content-end">
                  <Nav.Link as={NavLink} to="/">
                    Switch Business
                  </Nav.Link>
                </Nav>
              </>
            )}
          </Container>
        </Navbar>
      ) : null}
    </>
  );
};

BusinessBar.propTypes = {
  auth: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(BusinessBar);
